/**
 * Default max width for primary page content below the main nav.
 * Keeps form-heavy and settings-like pages aligned with Organization Settings.
 */
export const PAGE_CONTENT_MAX_CLASS = 'max-w-3xl';
